<acabim-card cardHeading="BIM Models"
             [cardContent]="cardContent"
             [isCollapsible]="true"
             [isCollapsed]="false"
             [hasHelpButton]="true"
             [helpMessage]="'You can view a list of models associated with this project and update any particular model.'"
             *ngIf="projectApiService.selectedProjectId$ | async"></acabim-card>

<ng-template #cardContent>
    <ng-container *ngIf="!showProgress; else loadingView">
        <acabim-datatable #dataTable [dataSources]="[this]" dataKey="modelId"></acabim-datatable>
    </ng-container>

    <ng-template #loadingView>
        <acabim-loading-view></acabim-loading-view>
    </ng-template>
</ng-template>

<acabim-modal title="Update Model" [display]="showUpdateModel" (close)="showUpdateModel = false">
    <acabim-admin-update-bim-model [model]="selectedData[0]"
                                   (closeDialog)="onModelUpdated($event)"></acabim-admin-update-bim-model>
</acabim-modal>
